module.exports = __webpack_public_path__ + "img/media (18).4050e0a1.png";